


export function RenderBooleanCell(fieldName: string, trueColor = "#4caf50", falseColor = "#f44336") {
  return (data: any) => {
    const rawValue = data.row[fieldName];
    return (
      <div
        style={{
          backgroundColor: rawValue === 1 ? trueColor : falseColor,
          color: "white",
          padding: "4px 12px",
          borderRadius: "4px",
          display: "inline-block",
          fontWeight: "bold",
        }}
      >
        {rawValue === 1 ? "是" : "否"}
      </div>
    );
  };
}
